var ContentTabsBlock = /** @class */ (function () {
    function ContentTabsBlock(element) {
        this.tabBlock = element;
        this.desktopTabToggles = this.tabBlock.querySelectorAll('[data-tab-target]');
        this.mobileTabToggles = this.tabBlock.querySelectorAll('[data-tab-item]');
        this.addEventListeners();
    }
    ContentTabsBlock.prototype.addEventListeners = function () {
        var _this = this;
        this.desktopTabToggles.forEach(function (tabItem) {
            tabItem.addEventListener('mouseenter', _this.toggleDesktopTab.bind(_this));
            tabItem.addEventListener('keydown', _this.handleDesktopTabKeyPress.bind(_this));
        });
        this.mobileTabToggles.forEach(function (tabItem) {
            var tabItemHeader = tabItem.querySelector('.item-header');
            tabItemHeader.addEventListener('click', _this.toggleTab.bind(_this));
            tabItemHeader.addEventListener('keydown', _this.handleMobileTabKeyPress.bind(_this));
        });
    };
    ContentTabsBlock.prototype.handleMobileTabKeyPress = function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
            this.toggleTab(event);
        }
    };
    ContentTabsBlock.prototype.toggleTab = function (event) {
        var currentItem = event.currentTarget;
        var tabItem = currentItem.parentElement;
        var tabTarget = tabItem.dataset.tabItem;
        var targetTabContent = this.tabBlock.querySelector("[data-tab-target=\"".concat(tabTarget, "\"]"));
        var tabContentIsOpen = tabItem.classList.contains('active');
        if (!tabContentIsOpen) {
            var tabContentItems = this.tabBlock.querySelectorAll('[data-tab-item]');
            tabContentItems.forEach(function (tabContent) { return tabContent.classList.remove('active'); });
            tabItem.classList.add('active');
            this.desktopTabToggles.forEach(function (tabToggle) { return tabToggle.classList.remove('active'); });
            targetTabContent.classList.add('active');
        }
    };
    ContentTabsBlock.prototype.handleDesktopTabKeyPress = function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
            this.toggleDesktopTab(event);
        }
    };
    ContentTabsBlock.prototype.toggleDesktopTab = function (event) {
        var tabToggle = event.currentTarget;
        var tabTarget = tabToggle.dataset.tabTarget;
        var targetTabContent = this.tabBlock.querySelector("[data-tab-item=\"".concat(tabTarget, "\"]"));
        var tabToggleIsActive = tabToggle.classList.contains('active');
        if (!tabToggleIsActive) {
            this.desktopTabToggles.forEach(function (tabToggle) { return tabToggle.classList.remove('active'); });
            tabToggle.classList.add('active');
            var tabContentItems = this.tabBlock.querySelectorAll('[data-tab-item]');
            tabContentItems.forEach(function (tabContent) { return tabContent.classList.remove('active'); });
            targetTabContent.classList.add('active');
        }
    };
    return ContentTabsBlock;
}());
var contentTabsBlocks = document.querySelectorAll('[data-content-tabs-block]');
contentTabsBlocks.forEach(function (contentTabBlock) {
    new ContentTabsBlock(contentTabBlock);
});
